import React from "react";

import styles from "./CostInput.module.scss";

/**
 * @param {String} [className] - additional className to add
 * @param {Number} value - the value of the cost input
 * @param {Function} onChange - event handler for cost input (should be setState from parent)
 */
const CostInput = props => {
    return (
        <div className={`${styles["cost-input"]} ${props.className || ""}`}>
            <i className={`fal fa-dollar-sign ${styles["cost-input-icon"]}`} />
            <input
                disabled={props.disabled || false}
                type="number"
                step="100"
                placeholder="0"
                value={props.value || 0}
                onChange={props.onChange}
                min="0"
            />
        </div>
    );
};

export default CostInput;
